"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadarThemeProvider = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
// Note that as a best practice the "core" package should not have dependencies.
// This will have to be moved to his own package.
var objects_1 = require("@radar-ui/objects");
var radar_1 = __importDefault(require("./themes/radar"));
var RadarThemeProvider = function (_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? {} : _b;
    var t = (0, objects_1.merge)(radar_1.default, theme);
    return react_1.default.createElement(styled_components_1.ThemeProvider, { theme: t }, children);
};
exports.RadarThemeProvider = RadarThemeProvider;
//# sourceMappingURL=theme-provider.js.map